import { generateRootObjectSchema, generateStringSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";

export const specification = new BaseAtomSpec("NV Play Match Centre", generateRootObjectSchema({
  container: generateAtomContainerSchema(),
  matchIdType: generateStringSchema("Match ID Type", "The type of ID being used in the Match IDs field.", {
    choices: ['nvplay', 'opta'],
    choiceTitles: ['NV Play', 'Opta'],
    defaultValue: 'nvplay',
  }),
  matchIds: generateStringSchema("Match ID", "The NV Play or Opta match ID. If not set, falls back to the gameId query-string parameter from the page URL."),
  source: generateStringSchema("Source", "Use \"nvplay\" to connect to the NV Play Cloud."),
  pollSeconds: generateStringSchema("Poll Seconds", "The number of seconds to wait before refreshing data. If empty or 0, data will not update until the page is reloaded."),
}));
